import React from 'react';
import { FooterListDownloadDataStyled } from './styles';

export interface Props {
  children: React.ReactNode;
}

export default function FooterListDownloadData({ children }: Props) {
  return (
    <FooterListDownloadDataStyled>{children}</FooterListDownloadDataStyled>
  );
}
